import { useStore } from "@src/stores";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useEffect, useState } from 'react';
import Scene from '@src/views/game/components/Scene'
import { Trans } from '@lingui/macro';
import { useNavigate } from 'react-router'
import Map from '@src/views/game/components/Mode/Map';
import AR from '@src/views/game/components/Mode/AR'
import { Modal } from "react-bootstrap";
import { Button } from "@src/components/Buttons/Button";
import Loader from "@src/components/Loader";
import { toJS, runInAction } from "mobx";
import { useRef } from 'react';
import { get, has } from 'lodash';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
const stepToMessage = (step: any): any[] => {
    const { __component, stepContent } = step;
    console.log('stepToMessage', toJS(stepContent))
    const messages: any[] = [];
    switch (__component) {
        case 'game.step-chat': {
            if (has(stepContent, 'content')) {
                messages.push({
                    delay: 0,
                    direction: 'incoming',
                    id: `preview-${Date.now()}`,
                    message: stepContent.content,
                    position: 'single',
                    sender: get(stepContent, 'relation.data.attributes.name', ''),
                    ...(has(stepContent, 'relation.data.attributes.avatar')
                        ? { avatar: get(stepContent, 'relation.data.attributes.avatar') }
                        : {}),
                    sentTime: 'now',
                    type: 'text',
                    processBy: 'stepper',
                });
            }
            const exportMessage = get(stepContent, 'export', 'background');
            if (exportMessage === 'image' && get(stepContent, 'image.data') !== null && get(stepContent, 'image', '')) {
                messages.push({
                    delay: 0,
                    direction: 'incoming',
                    id: `preview-img-${Date.now()}`,
                    message: '',
                    position: 'single',
                    sender: get(stepContent, 'relation.data.attributes.name', ''),
                    ...(has(stepContent, 'relation.data.attributes.avatar')
                        ? { avatar: get(stepContent, 'relation.data.attributes.avatar') }
                        : {}),
                    sentTime: 'now',
                    type: 'image',
                    image: get(stepContent, 'image', ''),
                    imageSize: 100,
                    processBy: 'stepper',
                });
            } else if (exportMessage === 'background' && get(stepContent, 'background.data') !== null && get(stepContent, 'background', '')) {
                messages.push({
                    delay: 0,
                    direction: 'incoming',
                    id: `preview-bg-${Date.now()}`,
                    message: '',
                    position: 'single',
                    sender: get(stepContent, 'relation.data.attributes.name', ''),
                    ...(has(stepContent, 'relation.data.attributes.avatar')
                        ? { avatar: get(stepContent, 'relation.data.attributes.avatar') }
                        : {}),
                    sentTime: 'now',
                    type: 'image',
                    image: get(stepContent, 'background', ''),
                    imageSize: 100,
                    processBy: 'stepper',
                });
            }
            break;
        }
        case 'game.step-message': {
            // if (has(stepContent, 'message') || ) {
            messages.push({
                ...stepContent,
                message: stepContent?.message || ''
            });
            console.log(toJS(messages))
            // }
            break;
        }
        case 'game.step-cutscene': {
            messages.push({
                delay: 0,
                direction: 'incoming',
                id: `preview-${Date.now()}`,
                videoId: stepContent.videoUrl,
                position: 'single',
                sender: get(stepContent, 'sender', ''),
                sentTime: 'now',
                type: 'video',
                processBy: 'stepper',
            });
            break;
        }
        case 'game.step-artifact-character':
        case 'game.step-artifact-item':
        case 'game.step-artifact-memory':
        case 'game.step-artifact-knowledge': {
            const data = get(stepContent, 'relation.data.attributes', {});
            messages.push({
                delay: 0,
                direction: 'incoming',
                id: `preview-${Date.now()}`,
                message: null,
                position: 'single',
                sender: get(stepContent, 'sender', ''),
                sentTime: 'now',
                type: 'artifact',
                processBy: 'stepper',
                imageSize: 100,
                avatar: stepContent.avatar,
                image: data.gallery,
                popup: {
                    videoId: data.videoUrl || '',
                    type: data.type || 'picture',
                    description: data.description,
                    name: data.name,
                    gallery: data.gallery,
                },
            });
            break;
        }
        default:
            break;
    }
    return messages;
};

const PreviewToolbar = observer(({ resetRef }: { resetRef?: React.MutableRefObject<(() => void) | null> }) => {
    const { fireStore } = useStore();
    const stepFlow = fireStore.currentScence?.stepFlow;
    const sceneType = fireStore.currentScence?.type?.[0]?.__component;
    const isMessageScene = sceneType === 'scene.message';
    const currentStepComponent = stepFlow?.[0]?.__component;
    const isMessageStep = currentStepComponent === 'game.step-message'
    const isResponseStep = currentStepComponent === 'game.step-message-response'
        || currentStepComponent === 'game.step-message-response-fork';
    const isSideMessageStep = currentStepComponent === 'game.step-chat'
        || currentStepComponent === 'game.step-cutscene'
        || currentStepComponent?.startsWith('game.step-artifact-');
    const prevStepsRef = useRef<any[]>([]);
    // Track message index within stepFlow for message navigation
    const local = useLocalObservable(() => ({ msgIndex: 0 }));
    // Each entry stores { messageCount } so we know how many messages to remove on prev
    const prevMessagesRef = useRef<{ messageCount: number }[]>([]);

    useEffect(() => {
        if (resetRef) {
            resetRef.current = () => {
                runInAction(() => { local.msgIndex = 0; });
                prevMessagesRef.current = [];
                prevStepsRef.current = [];
            };
        }
        return () => { if (resetRef) resetRef.current = null; };
    }, [resetRef, local]);

    const handleNextStep = () => {
        if (!stepFlow || stepFlow.length <= 1) return;
        runInAction(() => {
            const arr = [...fireStore.currentScence.stepFlow];
            const first = arr.shift();
            prevStepsRef.current.push(first);
            if (arr[0]?.__component === 'game.start-meditation' && arr[0]?.stepContent?.timer) {
                const [hours, minutes, seconds] = arr[0].stepContent.timer.split(':');
                arr[0].stepContent.end = dayjs()
                    .add(dayjs.duration({ hours: +hours, minutes: +minutes, seconds: +seconds }))
                    .valueOf();
            }
            fireStore.currentScence = {
                ...toJS(fireStore.currentScence),
                stepFlow: arr,
            };
            local.msgIndex = 0;
            if (isSideMessageStep) {
                handleNextMessage(arr, local);
            }
        });
    };

    const handlePrevStep = () => {
        if (prevStepsRef.current.length === 0) return;
        runInAction(() => {
            if (isSideMessageStep) {
                handlePrevMessage(fireStore.currentScence.stepFlow, local); // Automatically load messages for the new step if it's a message step
            }
            const prev = prevStepsRef.current.pop();
            const arr = [prev, ...fireStore.currentScence.stepFlow];
            fireStore.currentScence = {
                ...toJS(fireStore.currentScence),
                stepFlow: arr,
            };
            if (Array.isArray(prev.stepContent)) {
                local.msgIndex = prev.stepContent.length; // Set to end of messages for this step
            } else {
                local.msgIndex = 0;
            }
        });
    };

    const handleNextMessage = (sf: typeof stepFlow, loc: typeof local) => {
        if (!sf || loc.msgIndex >= sf.length) return;
        const step = sf[0];
        if (!step) return;
        runInAction(() => {
            let newMessages = null
            if (Array.isArray(step.stepContent)) {
                const newStep = toJS(step)
                newStep.stepContent = step.stepContent[loc.msgIndex];
                newMessages = stepToMessage(newStep)
            } else {
                newMessages = stepToMessage(step);
            }
            const currentMessages = [...(fireStore.gameMessage?.messages || [])];
            currentMessages.push(...newMessages);
            fireStore.gameMessage = { ...toJS(fireStore.gameMessage), messages: currentMessages };
            prevMessagesRef.current.push({ messageCount: newMessages.length });
            loc.msgIndex++;
        });
    };

    const handleResponse = (option: any) => {
        if (!stepFlow?.[0]) return;
        runInAction(() => {
            const currentMessages = [...(fireStore.gameMessage?.messages || [])];
            if (option.title) {
                currentMessages.push({
                    delay: 0,
                    direction: 'outgoing',
                    id: `preview-response-${Date.now()}`,
                    message: option.title,
                    position: 'single',
                    sender: 'you',
                    sentTime: 'now',
                    type: 'text',
                    processBy: 'stepper',
                });
                fireStore.gameMessage = { ...toJS(fireStore.gameMessage), messages: currentMessages };
                prevMessagesRef.current.push({ messageCount: 1 });
            }
        });
        handleNextStep();
    };

    const handlePrevMessage = (sf: typeof stepFlow, loc: typeof local) => {
        if (prevMessagesRef.current.length === 0 || loc.msgIndex <= 0) return;
        runInAction(() => {
            const { messageCount } = prevMessagesRef.current.pop()!;
            const currentMessages = [...(fireStore.gameMessage?.messages || [])];
            currentMessages.splice(currentMessages.length - messageCount, messageCount);
            fireStore.gameMessage = { ...toJS(fireStore.gameMessage), messages: currentMessages };
            loc.msgIndex--;
        });
    };

    const btnStyle = (disabled: boolean) => ({
        background: '#4f8cff',
        color: '#fff',
        border: 'none' as const,
        borderRadius: 8,
        padding: '8px 20px',
        cursor: 'pointer' as const,
        fontWeight: 600,
        fontSize: 14,
        opacity: disabled ? 0.5 : 1,
    });
    return (
        <div style={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 9999,
            display: 'flex',
            gap: 8,
            background: 'rgba(0,0,0,0.7)',
            borderRadius: 12,
            padding: '8px 16px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
            flexWrap: 'wrap',
            justifyContent: 'center',
        }}>
            <button
                onClick={handlePrevStep}
                disabled={prevStepsRef.current.length === 0}
                style={btnStyle(prevStepsRef.current.length === 0)}
            >
                ◀ Prev Step
            </button>
            <button
                onClick={handleNextStep}
                disabled={!stepFlow || isResponseStep || stepFlow.length <= 1 || (currentStepComponent === 'game.step-message' && local.msgIndex < stepFlow[0]?.stepContent?.length)}
                style={btnStyle(!stepFlow || isResponseStep || stepFlow.length <= 1 || (currentStepComponent === 'game.step-message' && local.msgIndex < stepFlow[0]?.stepContent?.length))}
            >
                Next Step ▶
            </button>

            {isMessageScene && <>
                <button
                    onClick={() => handlePrevMessage(stepFlow, local)}
                    disabled={prevMessagesRef.current.length === 0 || !isMessageStep}
                    style={{ ...btnStyle(prevMessagesRef.current.length === 0 || !isMessageStep), background: '#ff8c4f' }}
                >
                    ◀ Prev Msg
                </button>
                <button
                    onClick={() => handleNextMessage(stepFlow, local)}
                    disabled={!stepFlow || !isMessageStep || local.msgIndex >= stepFlow[0].stepContent.length}
                    style={{ ...btnStyle(!stepFlow || !isMessageStep || local.msgIndex >= stepFlow[0].stepContent.length), background: '#ff8c4f' }}
                >
                    Next Msg ▶
                </button>
            </>}
            {isResponseStep && stepFlow?.[0]?.stepController?.map((option: any, idx: number) => (
                <button
                    key={idx}
                    onClick={() => handleResponse(option)}
                    style={{ ...btnStyle(false), background: '#4fc34f' }}
                >
                    {option.title || `>`}
                </button>
            ))}
        </div>
    );
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Daemon = ({ children }: any) => {
    const [blurStart, setBlurStart] = useState(Date.now())
    const [showModal, setShowModal] = useState(false)
    const navigate = useNavigate()

    const onFocus = function () {
        console.debug("Tab is in focus");
        if (Date.now() - blurStart > 3000 * 60 * 1) {
            setShowModal(true)
        }
    };
    const onBlur = function () {
        console.debug("Tab is blurred");
        setBlurStart(Date.now())
    };
    useEffect(() => {
        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);
        return () => {
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
        };
    }, [blurStart]);
    return <>
        <Modal height={'100%'} centered show={showModal}>
            <Modal.Body>
                <div>
                    <h3><Trans>You&apos;ve been idle for a while</Trans></h3>
                    <Button
                        color={'primary'}
                        theme={'dark'}
                        text={<Trans>I am back</Trans>}
                        onClick={() => {
                            navigate(0);
                            setShowModal(false)
                        }} />
                </div>
            </Modal.Body>
        </Modal>
        {children}
    </>
};

export default observer(() => {
    const { fireStore } = useStore();
    const [dataReceived, setDataReceived] = useState(false);
    const [pendingData, setPendingData] = useState<any>(null);
    const lastUpdatedAtRef = useRef<string | null>(null);
    const toolbarResetRef = useRef<(() => void) | null>(null);
    console.log(toJS(fireStore.currentScence?.stepFlow), 'currentScence')
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            console.log('Received message:', event);
            const { type, data } = event.data || {};
            if (type === 'preview-data') {
                const incomingUpdatedAt = data?.currentScene?.updatedAt;
                if (lastUpdatedAtRef.current && incomingUpdatedAt === lastUpdatedAtRef.current) {
                    return;
                }
                if (dataReceived) {
                    setPendingData(data);
                } else {
                    const { gameResources, currentScene, gameMessage } = data;
                    if (gameResources) fireStore.gameResources = gameResources;
                    if (currentScene) fireStore.currentScence = currentScene;
                    if (gameMessage) fireStore.gameMessage = gameMessage;
                    fireStore.gameStatus = ['remote'];
                    lastUpdatedAtRef.current = incomingUpdatedAt ?? null;
                    setDataReceived(true);
                }
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [fireStore, dataReceived]);

    const applyPendingData = () => {
        if (!pendingData) return;
        const { gameResources, currentScene, gameMessage } = pendingData;
        if (gameResources) fireStore.gameResources = gameResources;
        if (currentScene) fireStore.currentScence = currentScene;
        if (gameMessage) fireStore.gameMessage = gameMessage;
        fireStore.gameStatus = ['remote'];
        lastUpdatedAtRef.current = pendingData?.updatedAt ?? null;
        toolbarResetRef.current?.();
        setPendingData(null);
    };

    if (
        !dataReceived
        || !fireStore.gameResources
        || !fireStore.currentScence
    ) return (
        <Loader />
    )

    let content;
    switch (fireStore.currentGameMode) {
        case 'map': {
            const resources = fireStore.gameResources;
            content = (
                <Daemon>
                    <Map resource={resources} />
                    <PreviewToolbar resetRef={toolbarResetRef} />
                </Daemon>
            );
            break;
        }
        case 'ar': {
            console.log('fireStore.localResources', fireStore.localResources);
            const resources = fireStore.localResources;
            content = (
                <Daemon>
                    <AR resource={resources} />
                    <PreviewToolbar resetRef={toolbarResetRef} />
                </Daemon>
            );
            break;
        }
        case 'getPermission':
        case 'remote':
        default: {
            const { type } = fireStore.currentScence;
            console.log('type', toJS(fireStore.currentScence))
            content = (
                <Daemon>
                    <Scene type={type[0]} />
                    <PreviewToolbar resetRef={toolbarResetRef} />
                </Daemon>
            );
            break;
        }
    }

    return (
        <>
            <div style={{ filter: pendingData ? 'blur(4px)' : 'none', pointerEvents: pendingData ? 'none' : 'auto', height: '100%' }}>
                {content}
            </div>
            {pendingData && (
                <div style={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: 10000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(0,0,0,0.4)',
                }}>
                    <button
                        onClick={applyPendingData}
                        style={{
                            background: '#4f8cff',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 12,
                            padding: '16px 40px',
                            fontSize: 18,
                            fontWeight: 700,
                            cursor: 'pointer',
                            boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
                        }}
                    >
                        <Trans>New data received, click to update</Trans>
                    </button>
                </div>
            )}
        </>
    );

})
